<template>
  <section id="contest_list_page">
      <contest-list></contest-list>
  </section>
</template>

<script>
import ContestList from '@/features/contests/contest_list.vue';

export default {
  name: 'ContestListPage',
  data () {
    return {
      msg: 'Welcome to Your Vue.js PWA'
    }
  },
  components: {
    ContestList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/ContestListPage.vue